import React, { useState, useRef } from "react";
import locale from "localization";
import styles from "./station-edit.module.scss";
import { FormMode, Path } from "enums";
import { Intro, BackLink, Loader } from "components/commons";
import StationDetailsModule from "../station-details/station-details.module";
import { useHistory } from "react-router-dom";
import { getStation } from "apis/station.api";
import { useApi, useMount } from "hooks";

const StationEditModule = (props) => {
  const routeParams = props.location?.state?.params ?? {};
  const stationDetailsRef = useRef();
  const history = useHistory();
  const [updateLoading, setUpdateLoading] = useState(false);
  const [disableUpdate, setDisableUpdate] = useState(true);
  const [stationData, setStationData] = useState(null);

  const { request: getStationRequest, loading: loadingStation } = useApi({
    api: getStation,
    pageError: true,
  });

  useMount(() => {
    if (routeParams?.stationId) {
      getStationRequest({ stationId: routeParams.stationId }).then((data) => {
        setStationData(data ?? routeParams);
      });
    } else {
      setStationData(routeParams);
    }
  });

  const isLoading = !stationData || loadingStation;

  return (
    <div>
      <BackLink text={locale.stationAccountList} path={Path.StationList} />
      <Loader open={isLoading} />
      {!isLoading && (
        <div className={styles.intro}>
          <Intro
            title={locale.seaoilStationDetails}
            actionText={locale.save}
            actionOnClick={() => stationDetailsRef.current?.handleUpdate()}
            actionClassName={styles.primarySaveButton}
            actionLoading={updateLoading}
            actionDisabled={disableUpdate}
            actionSecondaryText={locale.cancel}
            actionSecondaryOutlined
            actionSecondaryOnClick={() => history.push(Path.StationList)}
            actionSecondaryClassName={styles.secondarySaveButton}
          />
          <StationDetailsModule
            pageMode={FormMode.Edit}
            stationData={stationData}
            setUpdateLoading={setUpdateLoading}
            setDisableUpdate={setDisableUpdate}
            ref={stationDetailsRef}
          />
        </div>
      )}
    </div>
  );
};

export default StationEditModule;
